import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Styles from "./ViewCustomerWishlist.module.css";
import { viewCustomerWishlistService } from "../../../Services/ApiServices";
import cancelIcon from "../../../Assets/cross.png";
import Profile from "../../../Assets/user_img.png";
import mail from "../../../Assets/email.png";
import phone from "../../../Assets/mbl.png";
import location from "../../../Assets/location_img.png";
import Loader from "../../../SharedComponents/Loader/Loader";

export default function ViewCustomerWishlist(props) {
  const navigate = useNavigate();
  const [viewData, setViewData] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [readmoreId, setReadmoreId] = useState([]);

  useEffect(() => {
    handleView();
  }, []);

  const handleView = () => {
    setIsLoader(true);
    viewCustomerWishlistService(props.id)
      .then((res) => setViewData(res.data))
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleData = () => {
    let updateData = viewData?.wishlist_products?.map((ele) => {
      if (ele?.unit_id) {
        return {
          ...ele,
          colorItem: ele?.product_image[0],
          selectedUnit: {
            id: ele?.unit_id,
            unit_id: ele?.unit_name,
            selling_price: ele?.selling_price,
            quantity: parseInt(ele?.product_quantity),
            min_quantity: ele?.min_quantity,
          },
        };
      }
      return {
        ...ele,
        colorItem: ele?.product_image[0],
      };
    });

    navigate("/store/categories", {
      state: {
        ...viewData,
        wishlist_products: [...updateData],
        fromCustomerWishlist: true,
      },
    });
  };

  const handleTotalAmount = (data) => {
    return data.reduce((prev, current) => prev + current?.total_price, 0);
  };

  return (
    <div>
      <Loader isLoader={isLoader} />

      <Modal show={props.state} onHide={props.onHide} size="lg" centered>
        <Modal.Body>
          {/* Header */}
          <div className={Styles.cancelImgParentContainer}>
            <p className="fontBold">
              View Customer <span className="orange">Product</span>
            </p>

            <img
              onClick={props.onHide}
              src={cancelIcon}
              alt="cancel"
              className={Styles.cancelImg}
            />
          </div>

          {/* Customer Info */}
          <div>
            <div className={Styles.usernameParentContainer}>
              <div className={Styles.usernameContainer}>
                <img className={Styles.img} src={Profile} alt="profile" />
                <p className={Styles.username}>{viewData?.customer_name}</p>
              </div>
            </div>

            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={phone} alt="phone" />
              <p className={Styles.detail}>{viewData?.mobile_no}</p>
            </div>

            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={mail} alt="mail" />
              <p className={Styles.detail}>{viewData?.email || "-"}</p>
            </div>

            {/* Address + Delivery Type */}
            <div className={Styles.addressRow}>
              {/* Address */}
              <div className={Styles.detailContainer}>
                <img
                  className={Styles.location}
                  src={location}
                  alt="location"
                />
                <p className={Styles.detail}>
                  {viewData?.address},
                  <br />
                  {viewData?.state_name},
                  <br />
                  {viewData?.city_name}.
                </p>
              </div>

              {/* Delivery Type */}
              <div className={Styles.deliveryType}>
                <span className={Styles.deliveryLabel}>Delivery Type</span>
                <p className={Styles.deliveryValue}>
                  {viewData?.delivery_type_name || "-"}
                </p>
              </div>
            </div>
          </div>

          {/* Wishlist Table */}
          {viewData?.wishlist_products?.length > 0 && (
            <div className={Styles.parentContainer}>
              <div className={Styles.childContainer + " mt-3"}>
                <table>
                  <thead>
                    <tr>
                      <th className={Styles.th + " label text-center"}>S.No</th>
                      <th className={Styles.productname + " label text-center"}>
                        Product Name
                      </th>
                      <th className={Styles.th + " label text-center"}>Qty</th>
                      <th className={Styles.th + " label text-center"}>Unit</th>
                      <th className="label text-center">Price</th>
                      <th className="label text-center">Total</th>
                    </tr>
                  </thead>

                  <tbody className={Styles.data}>
                    {viewData.wishlist_products.map((e, index) => (
                      <tr key={e.product_id}>
                        <td className="text-center">{index + 1}</td>

                        <td
                          className={
                            Styles.productname + " contentFont text-center"
                          }
                        >
                          {readmoreId.includes(e.product_id)
                            ? e.product_name
                            : e.product_name.substring(0, 37)}
                          {e.product_name.length > 37 &&
                          !readmoreId.includes(e.product_id)
                            ? "..."
                            : null}

                          {e.product_name.length > 37 && (
                            <span
                              className={Styles.readmore + " orange"}
                              onClick={() =>
                                setReadmoreId((prev) =>
                                  prev.includes(e.product_id)
                                    ? prev.filter((id) => id !== e.product_id)
                                    : [...prev, e.product_id],
                                )
                              }
                            >
                              {readmoreId.includes(e.product_id)
                                ? "Show Less"
                                : "Read More"}
                            </span>
                          )}
                        </td>

                        <td className={Styles.td}>{e.quantity}</td>
                        <td className={Styles.td}>{e.unit_name || "-"}</td>
                        <td className={Styles.td}>
                          ₹ {e.selling_price.toFixed(2)}
                        </td>
                        <td className={Styles.td}>
                          ₹ {e.total_price.toFixed(2)}
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td colSpan={4} />
                      <td className="label text-center">Total</td>
                      <td className="label text-center">
                        ₹{" "}
                        {handleTotalAmount(viewData.wishlist_products).toFixed(
                          2,
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Action Button */}
          <div className={Styles.btnContainer}>
            <button onClick={handleData} className={Styles.btn}>
              Generate Bill
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
